export default __webpack_public_path__ + "images/5a4e1dc3e8dd7b3133187b54e47ad0ce.svg";